/** Shared class tokens for the admin console — keeps every section consistent. */

export const adminCard = "rounded-xl border border-background-200 bg-background-50";

export const adminInput =
  "h-10 w-full rounded-lg border border-background-300 bg-background-50 px-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100 disabled:cursor-not-allowed disabled:bg-background-100 disabled:text-foreground-500";

export const adminLabel = "mb-1.5 block text-xs font-semibold uppercase tracking-wider text-foreground-600";

export const adminBtnPrimary =
  "inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60";

export const adminBtnGhost =
  "inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-xs font-semibold text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-60";

export const adminBtnDanger =
  "inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-rose-200 bg-rose-50 px-4 py-2 text-xs font-semibold text-rose-700 transition-colors hover:bg-rose-100 disabled:cursor-not-allowed disabled:opacity-60";

export const adminIconBtn =
  "flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900";

export const adminTh = "px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-foreground-500";
export const adminTd = "px-4 py-3.5 text-sm text-foreground-700";

/** Status → badge classes for shared status pills. */
export const STATUS_BADGE: Record<string, string> = {
  active:    "bg-emerald-100 text-emerald-700",
  approved:  "bg-emerald-100 text-emerald-700",
  paid:      "bg-emerald-100 text-emerald-700",
  pending:   "bg-amber-100 text-amber-700",
  expiring:  "bg-amber-100 text-amber-700",
  paused:    "bg-amber-100 text-amber-700",
  inactive:  "bg-background-200 text-foreground-600",
  suspended: "bg-rose-100 text-rose-700",
  rejected:  "bg-rose-100 text-rose-700",
  expired:   "bg-rose-100 text-rose-700",
  cancelled: "bg-background-200 text-foreground-600",
  removed:   "bg-rose-100 text-rose-700",
  draft:     "bg-background-200 text-foreground-600",
};

export function statusBadge(status: string): string {
  return STATUS_BADGE[status.toLowerCase()] ?? "bg-background-200 text-foreground-600";
}